import axios from "axios";

const axiosFetch = async ({ url, method = "GET", data = null }) => {
  try {
    const token = sessionStorage.getItem("token");

    const response = await axios({
url: `${process.env.REACT_APP_API_URL}/${url}`,
      method,
      data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : ""
      }
    });

    return response;
  } catch (error) {
    console.log("API ERROR:", error?.response?.data || error.message);

    // SAFE fallback (prevents React crash)
    return { data: [] };
  }
};

export default axiosFetch;